export default __webpack_public_path__ + "static/media/leader_notes_detailed.4a2aa3e7.pdf";